import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  addPaymentCard: 'اضف بطاقة جديدة',
  saveCardData: 'حفظ بيانات البطاقة',
  planSummary: 'ملخص الطلب',
  changePlan: 'تغيير الخطة',
  automaticRenewalMonthly:
    'سيتم التجديد تلقائياً كل شهر. يمكننك الالغاء في اي وقت',
  automaticRenewal:
    'سيتم التجديد تلقائياً كل {{duration}} اشهر. يمكننك الالغاء في اي وقت',
  nonAutoRenewal:
    'قيمة الاشتراك تُدفع لمدة شهر واحد فقط، وهي غير متجددة تلقائيًا',
  totalFees: 'اجمالي المستحق ',
  selectPlane: 'اختر خطتك المثالية',
  selectPlanDescription:
    'اختر الخطة التى تناسبك واستمتع بمزايا غير محدودة و بأفضل سعر ',
  benefits: 'المميزات:',
  pointsValue: '{{value}} نقطة',
  point: 'نقطة',
  addAndFeaturingAds: '(لإضافة وتمييز الاعلانات) ',
  pointsExpiry: 'صلاحية النقاط:',
  expiryDays: '{{number}} يوم',
  subscribeNow: 'اشترك الآن',
  mostSell: 'الأكثر مبيعاً',
  noPlansFound: 'لا توجد خطط الآن متاحة للاشتراك .',
  recommended: 'مفضلة',
  bestSeller: 'الأكثر مبيعا',
  biggestDiscount: 'أكبر خصم',
  specialOffer: 'عرض خاص',
  bestForBranding: 'تسويق العلامة التجارية',
  freeTrialDays: 'تجربة مجانية لمدة {{days}} ايام',
  freeTrial: 'التجربة المجانية: <tag>0.00 جنيه ل {{days}} ايام</tag>',
  freeTrialStartDate: 'بداية من {{date}} : <tag>{{price}} جنيه/ شهر</tag>',
  duplicateTrial: 'لا يمكن استخدام التجربة المجانيه اكثر من مره',
  aqarmap: 'عقارماب',
  toAddListings: 'لإضافة إعلانات',
  noPropertyListing: 'هذا الاشتراك لا يشمل إضافة عقار.',
  month: 'شهر',
  months: 'شهور',
  saveIt: 'وفر',
  planPrice: 'سعر الباقة',
  discountPercentage: ' الباقة بخصم {{percentage}}% ',
  subscriptionQuarterly: 'ربع سنوى',
  subscriptionYearly: 'سنوياً',
  subscriptionSave50: 'وفر 50%',
  subscriptionPriceWithPeriod:
    '<price>{{price}} {{unit}}</price><period>{{period}}</period>',
});
